import Service from "./Service"

class VehicleLogService extends Service {

    getVehicleLogs = (id, queryParams) => this.get(`/vehicle/${id}/logs`, queryParams)

    getVehicleLog = (id) => this.get(`/vehicle-logs/${id}`)

    createVehicleLog = (requestBody) => this.postFile("/vehicle-logs", requestBody)

    updateVehicleLog = (id, requestBody) => this.patch(`/vehicle-logs/${id}`, requestBody)

    delete = (id) => this.del(`/vehicle-logs/${id}`)
}

const vehicleLogService = new VehicleLogService()
export default vehicleLogService